import { Contact } from '../types/Contact';
import { LoginResponse } from '../types/Auth';
import axios from 'axios';

//const BASE_URL = 'http://192.168.14.140:8000'; // ajusta si usas otro puerto o dominio
const API_URL = process.env.REACT_APP_API_URL;

// ==================== CONFIGURACIÓN GLOBAL DE AXIOS ====================
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor: agregar token automáticamente a todas las peticiones
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  
  // if (token) {
  //   config.headers = {
  //     ...config.headers,
  //     Authorization: `Bearer ${token}`,
  //   };
  // }
  
  if (!token) return config;

  config.headers = config.headers ?? {};
  config.headers.set("Authorization", `Bearer ${token}`);

  return config;
});

// ==================== AUTH ====================
export async function login(email: string, password: string): Promise<LoginResponse>  {
  const params = new URLSearchParams();
  params.append('username', email); // backend lo interpreta como email
  params.append('password', password);
  
  const response = await axios.post(`${API_URL}/auth/login`, params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

  //console.log(response.data);

  return response.data as LoginResponse;
}

// ==================== FUNCIONES CON AXIOS (usando el helper) ====================
export const fetchContacts = async (
  search: string,
  token: string,
  page: number,
  pageSize: number,
  empresa?: string,
  ocupacion?: string
) => {
  const skip = (page - 1) * pageSize;
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  if (empresa) params.append('empresa', empresa);
  if (ocupacion) params.append('ocupacion', ocupacion);
  params.append('skip', skip.toString());
  params.append('limit', pageSize.toString());

  const response = await fetch(`${API_URL}/contacts?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) throw new Error('Error al obtener contactos');
  
  return await response.json();
};

export async function fetchContactDetails(id: number, token: string) {
  const res = await fetch(`${API_URL}/contacts/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Failed to fetch details');
  return res.json();
}

export async function deleteContact(id: number, token: string) {
  const res = await fetch(`${API_URL}/contacts/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Failed to delete contact');
}

export const updateContact = async (id: number, contact: Contact, token: string) => {
  const response = await fetch(`${API_URL}/contacts/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(contact),
  });
  if (!response.ok) throw new Error('Error al actualizar contacto');
  return await response.json();
};

export async function updateLogout(logId: number, token: string) {
  try {
    const response = await fetch(`${API_URL}/auth/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({ log_id: logId })
    });

    if (!response.ok) {
      throw new Error("Error al registrar logout");
    }

    return await response.json();
  } catch (error) {
    console.error("updateLogout error:", error);
    throw error;
  }
}

// ==================== EXPORTAR EL CLIENTE API ====================
export { api };